import { createSelector } from 'reselect'

import { FETCH_STATUS } from '../constants'
import { NAME } from './reducer'

const byId = state => state[NAME].byId
export const getAllIncidentIds = state => state[NAME].allKeys
export const getSelectedIncidentIds = state => state[NAME].selected.incidentIds
export const getCurrentSelectedIndex = state => state[NAME].selected.current
const fetchStatus = state => state[NAME].fetchStatus

export const getIncidentById = createSelector([byId], byId => id =>
  byId[id] || null
)

export const getAllIncidents = createSelector(
  [getIncidentById, getAllIncidentIds],
  (byId, allKeys) => allKeys.map(byId)
)

const getSelectedIncidentId = createSelector(
  [getSelectedIncidentIds, getCurrentSelectedIndex],
  (incidentIds, current) => incidentIds[current]
)

export const getAllSelectedIncidents = createSelector(
  [getSelectedIncidentIds, getIncidentById],
  (incidentIds, byId) => incidentIds.map(byId)
)

export const getSelectedCount = createSelector(
  [getSelectedIncidentIds],
  selectedIds => selectedIds.length
)

export const getCurrentSelectedIncident = createSelector(
  [getSelectedIncidentId, getIncidentById],
  (selectedId, byId) => byId(selectedId)
)

export const getIsLoading = createSelector(
  [fetchStatus],
  fetchStatus => fetchStatus === FETCH_STATUS.FETCHING
)
